export default [
  {
    path: '/children',
    name: 'adding-new-child',
    component: () => import('@/views/Registration/AddingNewChild.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/application/select-child/:id',
    name: 'application-select-child',
    component: () => import('@/views/Application/ApplicationSelectChild.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/:slug',
    name: 'application-select-child',
    component: () => import('@/views/Application/ApplicationSelectChild.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/application/:id',
    name: 'application-create',
    component: () => import('@/views/Application/ApplicationSteps.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/application-submission/:id',
    name: 'my-applications-submission',
    component: () => import('@/views/My/ApplicationSubmission'),
    meta: {
      requiresAuth: true,
    }
  },
]
